import { render, staticRenderFns } from "./SalesOrderPage.vue?vue&type=template&id=2f4444bc&scoped=true"
import script from "./SalesOrderPage.vue?vue&type=script&lang=js"
export * from "./SalesOrderPage.vue?vue&type=script&lang=js"
import style0 from "./SalesOrderPage.vue?vue&type=style&index=0&id=2f4444bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4444bc",
  null
  
)

export default component.exports